var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDot(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 1.78125C3.96484 1.78125 1.53125 4.24219 1.53125 7.25C1.53125 10.2852 3.96484 12.7188 7 12.7188C10.0078 12.7188 12.4688 10.2852 12.4688 7.25C12.4688 4.24219 10.0078 1.78125 7 1.78125ZM7 0.46875C10.7188 0.46875 13.7812 3.53125 13.7812 7.25C13.7812 10.9961 10.7188 14.0312 7 14.0312C3.25391 14.0312 0.21875 10.9961 0.21875 7.25C0.21875 3.53125 3.25391 0.46875 7 0.46875ZM7 5.0625C8.20312 5.0625 9.1875 6.04688 9.1875 7.25C9.1875 8.48047 8.20312 9.4375 7 9.4375C5.76953 9.4375 4.8125 8.48047 4.8125 7.25C4.8125 6.04688 5.76953 5.0625 7 5.0625Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDot);
export default __webpack_public_path__ + "static/media/dot.72584202e12c952929db7ea0951e7d15.svg";
export { ForwardRef as ReactComponent };